module.exports = __webpack_public_path__ + "img/nav-logo-awaken.627b980b.webp";